import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import { keyframes, styled } from "@mui/material/styles";
import { FlexBox } from "src/lib/components/salify-next-layout/default/components/flex-box";
import { SearchOutlined } from "@mui/icons-material";
import { layoutConstant } from "src/lib/utils/constants";
import { NavLink } from "src/lib/components/salify-next-layout/default/components/nav-link";
const slideDown = keyframes`
    from {transform: translateY(-200%)}
    to {transform: translateY(0)}
`;
export const StyledRoot = styled(Box, {
  shouldForwardProp: (props) => props !== "bgColor",
})(({ theme, bgColor, expand }) => ({
  fontSize: 12,
  height: layoutConstant.topbarHeight,
  color: theme.palette.secondary.contrastText,
  background: bgColor || theme.palette.grey[900],
  transition: "height 300ms ease",
  "& .menuItem": {
    minWidth: 100,
  },
  "& .marginRight": {
    marginRight: "1.25rem",
  },
  "& .expand": {
    display: "none",
    padding: 0,
  },
  "& .handler": {
    height: layoutConstant.topbarHeight,
  },
  "& .menuTitle": {
    fontSize: 12,
    marginLeft: "0.5rem",
    fontWeight: 600,
  },
  [theme.breakpoints.down("sm")]: {
    height: expand ? 80 : layoutConstant.topbarHeight,
    "& .topbarRight": {
      display: expand ? "flex" : "none",
      paddingBottom: 5,
    },
    "& .expand": {
      display: "block",
      height: layoutConstant.topbarHeight,
    },
    "& .MuiSvgIcon-root": {
      color: "white",
    },
  },
}));
export const StyledContainer = styled(Container)(({ theme }) => ({
  height: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  [theme.breakpoints.down("sm")]: {
    alignItems: "start",
    flexDirection: "column",
  },
}));
export const StyledHeaderContainer = styled(Container)({
  gap: 8,
  height: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
});
export const Wrapper = styled("div")(({ theme }) => ({
  display: "none",
  left: 0,
  right: 0,
  bottom: 0,
  position: "fixed",
  width: "100vw",
  justifyContent: "space-around",
  zIndex: theme.zIndex.drawer - 1,
  height: layoutConstant.mobileNavHeight,
  backgroundColor: theme.palette.background.paper,
  boxShadow: "0px 1px 4px 3px rgba(0, 0, 0, 0.1)",
  [theme.breakpoints.down("md")]: {
    display: "flex",
  },
}));
export const HeaderWrapper = styled("div")(({ theme }) => ({
  zIndex: 3,
  position: "relative",
  height: layoutConstant.headerHeight,
  transition: "height 250ms ease-in-out",
  background: theme.palette.background.paper,
  [theme.breakpoints.down("sm")]: {
    height: "auto",
    minHeight: layoutConstant.mobileHeaderHeight,
  },
  boxShadow: theme.shadows[2],
}));
export const HotlineText = styled("span")(({ color }) => ({
  fontWeight: "bold",
  color: color || "#38B261",
}));
export const StyledBox = styled("div", {
  shouldForwardProp: (prop) => prop !== "componentHeight" && prop !== "fixed" && prop !== "fixedOn",
})(({ theme, componentHeight, fixedOn, fixed }) => ({
  paddingTop: fixed ? componentHeight : 0,
  "& .hold": {
    zIndex: 5,
    boxShadow: "none",
    position: "relative",
  },
  "& .fixed": {
    left: 0,
    right: 0,
    zIndex: 6,
    position: "fixed",
    top: `${fixedOn}px`,
    boxShadow: theme.shadows[2],
    transition: "all 350ms ease-in-out",
    animation: `${slideDown} 400ms ${theme.transitions.easing.easeInOut}`,
  },
}));
export { SearchResultCard } from "../search-result-card";
export const DropDownHandler = styled(FlexBox)(({ theme }) => ({
  whiteSpace: "pre",
  borderTopRightRadius: 2,
  borderBottomRightRadius: 2,
  borderLeft: `1px solid ${theme.palette.text.disabled}`,
  [theme.breakpoints.down("xs")]: {
    display: "none",
  },
}));
export const SearchOutlinedIcon = styled(SearchOutlined)(({ theme }) => ({
  color: theme.palette.grey[600],
  marginRight: 6,
}));
export const iconStyle = {
  display: "flex",
  marginBottom: "4px",
  alignItems: "center",
  justifyContent: "center",
};
export const StyledNavLink = styled(NavLink)({
  flex: "1 1 0",
  display: "flex",
  fontSize: "13px",
  alignItems: "center",
  flexDirection: "column",
  justifyContent: "center",
});
